import { useTranslation } from 'react-i18next';
import { ActionItemButton } from '@components/button/src/action-button';

import { MenuVenueRoutes } from './menu-venue.types';

export const MenuVenueOptions = ({
  menuOptions,
  handleClickClub,
}: {
  menuOptions: { id: string; label: string }[];
  handleClickClub: (route: MenuVenueRoutes) => void;
}) => {
  const { t } = useTranslation();
  return (
    <div className='flex flex-col gap-2 justify-end w-full shadow-sm rounded-md overflow-auto bg-primary p-8 pb-12 pt-10'>
      <p className='text-left text-body-xs mb-2 text-secondary'>{t('common:optionsLabel')}</p>
      {menuOptions.map((option) => (
        <ActionItemButton
          key={`option-menu-${option.id}`}
          active={false}
          onClick={() => handleClickClub(option.id as MenuVenueRoutes)}
          text={option.label}
        />
      ))}
    </div>
  );
};
